<template>
  <CCardBody>
    <div class="text-right btngroup top_buttons">
        <b-button
            class="deleteBtn"
            size="lg"
            @click="DeleteFactories"
        >
            Delete
        </b-button>
        <CButton
        class="addBtn ml-3"
        @click="showModal"
        >
        Create
        </CButton>
    </div>
    <b-alert v-if="select_factory" show variant="danger">Select atleast 1 factory</b-alert>
    <search-items v-model="search" :searchHandler="searchFactory" :placeholder="'Type to search'"></search-items>
    <b-table
        :items="factories"
        :fields="titles"
        hover
        sorter
    >
      <template #cell(title_actions)="item">
        <pencil class="edit_factory" @click="editFactory(item.item)" fillColor="#009FE3" :id="item.item.id" />

        <span style="font-size: 30px; display: inline-block; cursor: pointer;"
              class="ml-2" v-b-tooltip.auto="`Assign Asana Project`"
              :id="item.id" @click="getAsanaWorkSpaces(item.item)">
              <svg viewBox="0 0 460.000000 255.000000" height="1em" width="1em"
                   preserveAspectRatio="xMidYMid meet" style="margin-top: 10px;">

              <g transform="translate(0.000000,455.000000) scale(0.100000,-0.100000)"
                 fill="currentColor" stroke="none">
                <path d="M180 3535 l0 -845 845 0 845 0 0 845 0 845 -845 0 -845 0 0 -845z
m1382 457 c37 -36 47 -96 25 -138 -9 -16 -193 -206 -409 -421 l-394 -393 -42
0 c-62 0 -85 15 -204 138 -83 85 -108 117 -113 145 -10 49 19 106 65 131 57
30 101 17 177 -57 l64 -61 332 332 c183 182 346 338 362 347 43 23 101 13 137
-23z"/>
                <path d="M2382 3908 l3 -123 978 -3 977 -2 0 125 0 125 -980 0 -981 0 3 -122z"/>
                <path d="M2380 3160 l0 -120 765 0 765 0 0 120 0 120 -765 0 -765 0 0 -120z"/>
              </g>
            </svg>
            </span>

      </template>
    </b-table>
    <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.rows"
        :per-page="pagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handlePagination"
        v-if="pagination.total > 0"
        :key="pagination.currentPage"
    ></b-pagination>

    <b-modal id="factoryModal"  @hidden="ResetForm" size="lg" no-close-on-backdrop  hide-footer>
        <template #modal-title>
            <span v-if="!form.name">Factory</span>
            <span v-else>{{form.name}}</span>
        </template>
        <b-alert v-for="item in getErrors" :key="item[0]" show variant="danger">{{item[0]}}</b-alert>
            <form-wizard ref="wizard"
                color="#009FE3"
                :title="null"
                :subtitle="null"
                @on-error="handleErrorMessage"
                @on-complete="submitForm"
            >
                <tab-content title="Core Data" :before-change="validateCoreData">
                    <form :model="form" class="demo-form-inline">
                        <div class="row mt-2">
                            <div class="col-md-6">
                                <b-form-group id="factory-name" label-for="factory-name">
                                    <label class="required">Factory Name</label>
                                    <b-form-input  id="name"  v-model="$v.form.name.$model" :state="validateState('name')" name="name" aria-describedby="name-2-feedback" ></b-form-input>
                                    <b-form-invalid-feedback id="name-feedback">This is a required field.</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group id="factory-id" label-for="factory-id">
                                    <label class="required">Factory ID</label>
                                    <b-form-input
                                        id="factory_id"
                                        v-model="$v.form.factory_id.$model"
                                        :state="validateState('factory_id')"
                                        name="factory_id"
                                        aria-describedby="factory-id-feedback"
                                    >
                                    </b-form-input>
                                    <b-form-invalid-feedback id="factory-id-feedback">This is a required field.</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group id="phone" label-for="phone">
                                    <label class="required">Phone (including extension)</label>
                                    <b-form-input
                                        id="phone"
                                        v-model="$v.form.phone.$model"
                                        :state="validateState('phone')"
                                        name="phone"
                                        aria-describedby="phone-feedback"
                                    >
                                    </b-form-input>
                                    <b-form-invalid-feedback id="phone-feedback">This is a required field.</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group id="address_1" label-for="address_1">
                                    <label class="required">Address</label>
                                    <b-form-input
                                        id="address_1"
                                        v-model="$v.form.address_1.$model"
                                        :state="validateState('address_1')"
                                        name="address_1"
                                        aria-describedby="address_1-feedback"
                                    >
                                    </b-form-input>
                                    <b-form-invalid-feedback id="address_1-feedback">This is a required field.</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group id="address_2" label-for="address_2">
                                    <label class="required">Address 2</label>
                                    <b-form-input
                                        id="address_2"
                                        v-model="$v.form.address_2.$model"
                                        :state="validateState('address_2')"
                                        name="address_2"
                                        aria-describedby="address_2-feedback"
                                    >
                                    </b-form-input>
                                    <b-form-invalid-feedback id="address_2-feedback">This is a required field.</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group id="city" label-for="city">
                                    <label class="required">City</label>
                                    <b-form-input
                                        id="city"
                                        v-model="$v.form.city.$model"
                                        :state="validateState('city')"
                                        name="city"
                                        aria-describedby="city-feedback"
                                    >
                                    </b-form-input>
                                    <b-form-invalid-feedback id="city-feedback">This is a required field.</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group id="post_code" label-for="post_code">
                                    <label class="required">Postcode</label>
                                    <b-form-input
                                        id="post_code"
                                        v-model="$v.form.post_code.$model"
                                        :state="validateState('post_code')"
                                        name="post_code"
                                        aria-describedby="post_code-feedback"
                                    >
                                    </b-form-input>
                                    <b-form-invalid-feedback id="post_code-feedback">This is a required field.</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group id="contact_person_name" label-for="contact_person_name">
                                    <label class="required">Contact Person</label>
                                    <b-form-input
                                        id="contact_person_name"
                                        v-model="$v.form.contact_person_name.$model"
                                        :state="validateState('contact_person_name')"
                                        name="contact_person_name"
                                        aria-describedby="contact_person_name-feedback"
                                    >
                                    </b-form-input>
                                    <b-form-invalid-feedback id="contact_person_name-feedback">This is a required field.</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <label>Country</label>
                                <v-select autocomplete="off" :options="counrtries" name="country_id" v-model="form.country_id" placeholder="Select Country">
                                <template slot="selected-option" slot-scope="option">
                                    <span :class="'mr-2 flag flag-'+option.code.toLowerCase()"></span> {{option.label}}
                                </template>
                                <template slot="option" slot-scope="option" class="option.code">
                                    <span :class="'mr-1 flag flag-'+option.code.toLowerCase()"></span>
                                    {{ option.label }}
                                </template>
                                </v-select>
                                <div v-if="errors" class="error_msg">
                                    {{errors.first('country_id')}}
                                </div>
                            </div>
                      </div>
                    </form>
                </tab-content>
                <tab-content title="Bank Info" :before-change="validateBankData">
                    <div class="row mt-2">
                        <form :model="bank" class="demo-form-inline">
                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group id="bank_name" label-for="bank_name">
                                        <label class="required">Bank Name</label>
                                        <b-form-input
                                            id="bank_name"
                                            v-model="$v.bank.bank_name.$model"
                                            :state="validateBank('bank_name')"
                                            name="bank_name"
                                            aria-describedby="bank_name-feedback"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback id="bank_name-feedback">This is a required field.</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group id="iban_no" label-for="iban_no">
                                        <label class="required">IBAN</label>
                                        <b-form-input
                                            id="iban_no"
                                            v-model="$v.bank.iban_no.$model"
                                            :state="validateBank('iban_no')"
                                            name="iban_no"
                                            aria-describedby="iban_no-feedback"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback id="iban_no-feedback">This is a required field.</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group id="swift_code" label-for="swift_code">
                                        <label class="required">SWIFT</label>
                                        <b-form-input
                                            id="swift_code"
                                            v-model="$v.bank.swift_code.$model"
                                            :state="validateBank('swift_code')"
                                            name="swift_code"
                                            aria-describedby="swift_code-feedback"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback id="swift_code-feedback">This is a required field.</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group id="invoice_currency" label-for="invoice_currency">
                                        <label class="required">Invoice Currency</label>
                                        <v-select
                                            autocomplete="off"
                                            id="invoice_currency"
                                            :options="options"
                                            name="invoice_currency"
                                            v-model="$v.bank.invoice_currency.$model"
                                            :state="validateBank('invoice_currency')"
                                            placeholder="Select Currency">
                                        </v-select>
                                        <b-form-invalid-feedback id="invoice_currency-feedback">This is a required field.</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group id="bank_address" label-for="bank_address">
                                        <label class="required">Address</label>
                                        <b-form-input
                                            id="bank_address"
                                            v-model="$v.bank.bank_address.$model"
                                            :state="validateBank('bank_address')"
                                            name="bank_address"
                                            aria-describedby="bank_address-feedback"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback id="bank_address-feedback">This is a required field.</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group id="bank_address_2" label-for="bank_address_2">
                                        <label class="required">Address 2</label>
                                        <b-form-input
                                            id="bank_address_2"
                                            v-model="$v.bank.bank_address_2.$model"
                                            :state="validateBank('bank_address_2')"
                                            name="bank_address_2"
                                            aria-describedby="bank_address_2-feedback"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback id="bank_address_2-feedback">This is a required field.</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group id="bank_city" label-for="bank_city">
                                        <label class="required">City</label>
                                        <b-form-input
                                            id="bank_city"
                                            v-model="$v.bank.bank_city.$model"
                                            :state="validateBank('bank_city')"
                                            name="bank_city"
                                            aria-describedby="bank_city-feedback"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback id="bank_city-feedback">This is a required field.</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group id="bank_postcode" label-for="bank_postcode">
                                        <label class="required">Postcode</label>
                                        <b-form-input
                                            id="bank_postcode"
                                            v-model="$v.bank.bank_postcode.$model"
                                            :state="validateBank('bank_postcode')"
                                            name="bank_postcode"
                                            aria-describedby="bank_postcode-feedback"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback id="bank_postcode-feedback">This is a required field.</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <label>Country</label>
                                    <v-select autocomplete="off" :options="counrtries" name="bank_country_id" v-model="bank.bank_country_id" placeholder="Select Country">
                                        <template slot="selected-option" slot-scope="option">
                                            <span :class="'mr-2 flag flag-'+option.code.toLowerCase()"></span> {{option.label}}
                                        </template>
                                        <template slot="option" slot-scope="option" class="option.code">
                                            <span :class="'mr-1 flag flag-'+option.code.toLowerCase()"></span>
                                            {{ option.label }}
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </form>
                    </div>
                </tab-content>
                <tab-content title="SKU's" v-if="form.id">
                  <b-table
                      :items="skus"
                      :fields="skusFields"
                      hover
                      sorter
                  >
                    <template v-slot:cell(description)="data">
                      <span v-html="data.value"></span>
                    </template>
                    <template  #cell(sku_actions)="item">
                      <pencil class="edit_factory ml-1" @click="editSku(item)" fillColor="#009FE3" :id="item.id" />
                      <delete class="edit_factory ml-2" @click="deleteSku(item.id)" fillColor="#E30000" :id="item.id" />
                    </template>
                  </b-table>

                </tab-content>
                <tab-content title="Cost Price" v-if="form.id">
                </tab-content>
            </form-wizard>
    </b-modal>

    <b-modal id="asanaProjectModal"  @hidden="ResetForm" size="lg" no-close-on-backdrop  hide-footer>
      <template #modal-title>
        Bind Asana Project with
        <span v-if="!asana_form.name">Factory</span>
        <span v-else>{{asana_form.name}}</span>
      </template>
      <CRow>
          <CCol class="col-12">
            <label class="required">Asana Workspaces</label>
            <v-select
                v-model="asana_form.asana_workspace_id"
                v-validate="{required: true}"
                :options="asana_workspaces"
                name="asana_workspaces"
                placeholder="Select Workspace"
                @input="onWorkspaceChange()"
            >
            </v-select>
            <div v-if="errors && errors.first('asana_workspace_id')" class="error_msg">
              {{errors.first('asana_workspace_id')}}
            </div>
          </CCol>
      </CRow>
      <CRow v-if="asana_form.asana_workspace_id.id">
          <CCol class="col-12">
            <label class="required">Asana Projects</label>
            <v-select
                v-model="asana_form.asana_project_id"
                v-validate="{required: true}"
                :options="asana_projects[asana_form.asana_workspace_id?.id] || [{ id: null, label: 'Select Asana project' }]"
                name="asana_project"
                placeholder="Select Project"
            >
            </v-select>
            <div v-if="errors && errors.first('asana_project_id')" class="error_msg">
              {{errors.first('asana_project_id')}}
            </div>
            <b-button @click="assignAsanaProject" class="mt-2 float-right" variant="primary">Assign</b-button>
          </CCol>
      </CRow>
    </b-modal>
  </CCardBody>
</template>
<script>
    import { required } from "vuelidate/lib/validators";
    import Pencil from 'vue-material-design-icons/GreasePencil.vue';
    import Delete from 'vue-material-design-icons/Delete.vue';
    import {getLastPage, getPageModal, removePageModal, setPageModal} from "@/helpers/Helpers";
    import SearchItems from "@/components/SearchItems.vue";
    import {http} from "@/config/httpCommon";
export default {
    components: {
        Pencil,
        Delete,
        SearchItems
    },
  props: {
    startIndex: {
      type: Number,
      default: 0
    }
  },
    name: 'Factories',
    validations: {
        form: {
            name:  {required},
            factory_id:  {required},
            phone:  {required},
            address_1:  {required},
            address_2:  {required},
            city:  {required},
            contact_person_name:  {required},
            post_code:  {required},
        },
        bank: {
            bank_name: {required},
            iban_no: {required},
            swift_code: {required},
            invoice_currency: {required},
            bank_address: {required},
            bank_address_2: {required},
            bank_city: {required},
            bank_postcode: {required},
        },
    },
    data () {
      return {
        select_factory: false,
        factories: [],
        options: [
            {
                id: 1,
                label: 'USD'
            },
            {
                id: 2,
                label: 'CAD'
            },
            {
                id: 3,
                label: 'EUR'
            },
            {
                id: 4,
                label: 'DKK'
            },
            {
                id: 5,
                label: 'SEK'
            },
        ],
        showModel:false,
        checkbox: [],
        text:'',
        errorMsg: null,
        titles: [
            {key: 'id', label: '', sorter: false},
            'name',
            'email',
            {key: 'title_actions', label: 'Actions'},
        ],
        skusFields: [
            {key: 'sku_id', label: 'SKU ID'},
            'description',
            {key: 'sku_actions', label: 'Actions'},
        ],
        startDate: 1325376000000,
        endDate: 1330560000000,
        modal: false,
        form: {
          id: '',
          name: '',
          address_1: '',
          city: '',
          contact_person_name: '',
          factory_id: '',
          address_2: '',
          post_code: '',
          country_id: '',
          phone: '',
        },
        bank: {
            bank_name: '',
            iban_no: '',
            swift_code: '',
            invoice_currency: '',
            bank_address: '',
            bank_address_2: '',
            bank_city: '',
            bank_postcode: '',
            bank_country_id: '',
        },
        skus: [],
        search: '',
        pagination:{
          rows:null,
          currentPage:null,
          perPage:null,
          total:0
        },
        asana_workspaces:[],
        asana_projects:{null:[]},
        asana_form: {
          selected_factory_id:null,
          name: '',
          asana_project_id:{id:null,label:'Select Asana project'},
          asana_workspace_id:{id:null,label:'Select Asana Workspace'}
        }
      }
    },
    computed: {
      counrtries(){
        return this.$store.getters.getCountries;
      },
      getErrors(){
        return this.$store.getters.getErrors;
      },
    },
    async created() {
      try{
            await this.$store.commit('set', ['showLoader', true]);
            await this.$store.dispatch('countries');
            this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getFactories)
            await this.$store.commit('set', ['showLoader', false]);
        }catch(err){
            await this.$store.commit('set', ['showLoader', false]);
            if(err.response.status==401){
                this.logout();
            }else{
                this.showErrors(err);
            }
        }
    },
    methods: {
      async getFactories(params){
       let res = await this.$store.dispatch('factories', params);
       this.factories = this.$store.getters.getFactories;
       this.makePagination(res.data);
      },
      makePagination(data){
        this.pagination.currentPage = data.meta.current_page;
        this.pagination.rows = data.meta.total;
        this.pagination.perPage = data.meta.per_page;
        this.pagination.total = data.meta.total;
      },
      searchFactory(){
        let params = ''
        if(this.search) {
          params = '?search='+this.search;
        }
        setPageModal(1,this.$route.name,this.search);
        this.getFactories(params);
      },
      async handlePagination(page=''){
        let params = '?page='+page;
        if(this.search) {
          params += '&search='+this.search
        }
        setPageModal(page,this.$route.name,this.search);
        this.getFactories(params);
      },
        validateState(name) {
          const { $dirty, $error } = this.$v.form[name];
          return $dirty ? !$error : null;
        },
        validateBank(name) {
          const { $dirty, $error } = this.$v.bank[name];
          return $dirty ? !$error : null;
        },
        handleErrorMessage: function(errorMsg){
          this.errorMsg = errorMsg
        },
        validateCoreData(){
            return new Promise((resolve) => {
            this.$v.form.$touch();
              if (this.$v.form.$anyError) {
                  console.log("errors: ",this.$v.form);
                 resolve(false);
              }
              resolve(true);
           })
        },
        validateBankData(){
            return new Promise((resolve) => {
            this.$v.bank.$touch();
              if (this.$v.bank.$anyError) {
                 resolve(false);
              }
              resolve(true);
           })
        },
        async ResetForm(){
            this.form.id = '';
            this.form.address_1 = ''
            this.form.address_2 = '';
            this.form.city = '';
            this.form.contact_person_name = '';
            this.form.country_id = '';
            this.form.factory_id = '';
            this.form.name = '';
            this.form.phone = '';
            this.form.post_code = '';
            this.bank.bank_name = '';
            this.bank.iban_no = '';
            this.bank.swift_code = '';
            this.bank.invoice_currency = '';
            this.bank.bank_address = '';
            this.bank.bank_address_2 = '';
            this.bank.bank_city = '';
            this.bank.bank_postcode = '';
            this.bank.bank_country_id = '';
            this.skus = [];
            this.asana_form.asana_project_id = {id:null,label:'Select Asana project'}
            this.asana_form.factory_id = '';
            this.asana_form.name = '';
            this.$v.$reset()
        },
        async submitForm(){

            var formData = {
                'id': this.form.id,
                'bank_name': this.bank.bank_name,
                'iban_no': this.bank.iban_no,
                'swift_code': this.bank.swift_code,
                'invoice_currency': this.bank.invoice_currency.id,
                'bank_address': this.bank.bank_address,
                'bank_address_2': this.bank.bank_address_2,
                'bank_city': this.bank.bank_city,
                'bank_country_id': this.bank.bank_country_id.id,
                'bank_post_code': this.bank.bank_postcode,
                'address_1': this.form.address_1,
                'address_2': this.form.address_2,
                'city': this.form.city,
                'contact_person_name': this.form.contact_person_name,
                'country_id': this.form.country_id.id,
                'factory_id': this.form.factory_id,
                'name': this.form.name,
                'phone': this.form.phone,
                'post_code': this.form.post_code,
            }
            try{
                if(this.form.id == ''){
                    await this.$store.dispatch('addFactory', formData);
                    this.showToast("Factory added successfully", 'SUCCESS');
                    this.factories = this.$store.getters.getFactories;
                    this.nextPageOnCreation('page','search', this.factories.length, this.pagination.perPage, this.pagination.currentPage, getLastPage(this.pagination.perPage ,this.pagination.total ), this.$route.name, this.getFactories);

                }else{
                    await this.$store.dispatch('updateFactory', {
                        'data': formData,
                        'id': this.form.id
                    });
                    this.factories = this.$store.getters.getFactories;
                    this.preservePagination('page','search',this.$route.name,this.getFactories);
                    this.showToast("Factory updated successfully", 'SUCCESS');
                }
                this.factories = this.$store.getters.getFactories;
                this.$bvModal.hide("factoryModal");
            }catch(err){
                let errRes = err.response.data.errors;
                let errArr = []
                Object.keys(errRes).map((field) => {
                    errArr.push(errRes[field][0]);
                });
                errArr = [ ...new Set(errArr) ];
                for(let i=0; i<errArr.length; i++){
                    this.showToast(errArr[i], 'DANGER');
                }
            }

        },
        async DeleteFactories(){
            if(this.checkbox.length <1){
                this.select_factory = true;
            }else{
                this.select_factory = false;
                try{
                    await this.$store.dispatch('deleteFactory', this.checkbox);
                    this.factories = this.$store.getters.getFactories;
                    this.previousPageOnDeletion('page', 'search', this.factories.length, this.$route.name, this.getFactories);
                    this.showToast("Factory Deleted", 'SUCCESS');
                }catch(err){
                    console.log("Error", err)
                }
            }
        },
        async updateTable(searchQry){
            this.search = searchQry;
            try{
                this.$store.commit('set', ['showLoader', true]);
                setPageModal(1,this.$route.name,this.search);
                await this.$store.dispatch('factories', '?name='+this.search);
                this.factories = this.$store.getters.getFactories;
                this.pages = this.$store.getters.totalPages;
                this.current_page = 1;
                this.$store.commit('set', ['showLoader', false]);
            }catch(err){
                this.$store.commit('set', ['showLoader', false]);
                console.log(err)
            }
        },
        async myFunction(currentPage){
            try{
            this.current_page=currentPage;
            let params = '?name='+this.search+'&page='+currentPage;
            this.$store.commit('set', ['showLoader', true]);
            await this.$store.dispatch('factories', params);
            this.$store.commit('set', ['showLoader', false]);
            this.skus = this.$store.getters.getSku;
            this.pages = this.$store.getters.totalPages;
            }catch(err){
                this.$store.commit('set', ['showLoader', false]);
                console.log("Error: ", err.response.data.errors);
            }
        },
        getSelectedCountry(id){
            let world = this.counrtries;
            for(let i = 0; i < world.length; i++){
                if(world[i].id == id){
                    return world[i];
                }
            }
        },
        getSelectedCurrency(id){
            for(let i = 0; i < this.options.length; i++){
                if(this.options[i].id == id){
                    return this.options[i];
                }
            }
        },
        async editFactory(factory){
            try{
                await this.$store.dispatch('getFactory', factory.id);
                this.form.id = factory.id;
                this.form.address_1 = factory.address;
                this.form.address_2 = factory.address_1;
                this.form.city = factory.city;
                this.form.contact_person_name = factory.contact_person_name;
                this.form.country_id = this.getSelectedCountry(factory.country_id);

                this.form.factory_id = factory.factory_id;
                this.form.name = factory.name;
                this.form.phone = factory.phone;
                this.form.post_code = factory.post_code;

                this.bank.bank_name = factory.bank ? factory.bank.bank_name: '';
                this.bank.iban_no = factory.bank ? factory.bank.iban_no : '';
                this.bank.swift_code = factory.bank ? factory.bank.swift_code: '';
                this.bank.invoice_currency = this.getSelectedCurrency(factory.bank ?factory.bank.invoice_currency:'');
                this.bank.bank_address = factory.bank ? factory.bank.bank_address:'';
                this.bank.bank_address_2 = factory.bank ? factory.bank.address_2: '';
                this.bank.bank_city = factory.bank ? factory.bank.city: '';
                this.bank.bank_postcode = factory.bank ?factory.bank.post_code: '';
                this.bank.bank_country_id = this.getSelectedCountry(factory.bank ? factory.bank.country_id: '');
                this.skus = this.$store.getters.getFactorySku;
                this.$bvModal.show("factoryModal");
            }catch(err){
                this.showErrors(err);
            }
        },
        async deleteSku(id){
            try{
                await this.$store.dispatch('deleteFactorySkus', [id]);
                // let factory_id = this.form.id;
                // console.log("id", id);
                // let factories = this.getFactories;
                // this.skus = [];
                // for (let index = 0; index < factories.length; index++) {
                //     if(factory_id == factories[index].id){
                //         let list = factories[index].skus;
                //         console.log(list, 'list');
                //         for (let i = 0; i < list.length; i++) {
                //             if(id != list[i].id){
                //                 this.skus.push(list[i]);
                //             }
                //         }
                //     }
                // }
                this.skus = this.$store.getters.getFactorySku;
                this.spinner = false;
                this.showToast('SKU deleted successfully', 'SUCCESS');
            }catch(err){
                this.showErrors(err);
            }
        },
        showErrors(err){
            let errRes = err.response.data.errors;
            let errArr = []
            Object.keys(errRes).map((field) => {
                errArr.push(errRes[field][0]);
            });
            errArr = [ ...new Set(errArr) ];
            for(let i=0; i<errArr.length; i++){
                this.showToast(errArr[i], 'DANGER');
            }
            this.spinner = false;
        },
      async showModal(){
        await this.ResetForm()
        this.$bvModal.show("factoryModal");
      },
      async onWorkspaceChange() {
        // Reset project when workspace changes
        this.asana_form.asana_project_id = { id: null, label: 'Select Asana project' };
        await this.getAsanaProjects();
    },
    async getAsanaWorkSpaces(factory) {
        this.asana_form.selected_factory_id = factory.id;
        this.asana_form.name = factory.name;
        this.asana_form.asana_workspace_id = { id: null, label: 'Select Asana workspace' };
        this.asana_form.asana_project_id = { id: null, label: 'Select Asana project' };
        this.$bvModal.show("asanaProjectModal");

        const workspaceId = factory.asana_workspace_id;

        // Load Asana workspaces if not already fetched
        if (this.asana_workspaces.length === 0) {
            await this.$store.commit('set', ['showLoader', true]);
            try {
            const res = await http.get(`/get-asana-workspaces`);
            const optionArray = [{ id: null, label: 'Select Asana workspace' }];

            res.data.forEach((obj) => {
                optionArray.push({ id: obj.gid, label: obj.name });
                if (workspaceId === obj.gid) {
                this.asana_form.asana_workspace_id = { id: obj.gid, label: obj.name };
                }
            });

            this.asana_workspaces = optionArray;
            } finally {
            await this.$store.commit('set', ['showLoader', false]);
            }
        } else {
            // Set workspace if already loaded
            const workspace = this.asana_workspaces.find(obj => obj.id === workspaceId);
            if (workspace) {
            this.asana_form.asana_workspace_id = { id: workspace.id, label: workspace.label };
            }
        }

        // Fetch projects if workspace is selected
        if (this.asana_form.asana_workspace_id?.id) {
            await this.getAsanaProjects(factory);
        }
    },
    async getAsanaProjects(factoryParam = null) {
        const workspaceId = this.asana_form.asana_workspace_id?.id;

        // Always reset project selection when workspace changes
        this.asana_form.asana_project_id = { id: null, label: 'Select Asana project' };

        if (!workspaceId) return;

        const factory = factoryParam || this.factories.find(obj => obj.id === this.asana_form.selected_factory_id);
        const currentProjectId = factory?.asana_project_id;

        // Use cached projects if available
        if (this.asana_projects[workspaceId]) {
            const cached = this.asana_projects[workspaceId].find(p => p.id === currentProjectId);
            if (cached) {
            this.asana_form.asana_project_id = { id: cached.id, label: cached.label };
            }
            return;
        }

        // Fetch from API
        await this.$store.commit('set', ['showLoader', true]);
        try {
            const res = await http.get(`/get-asana-projects?asana_workspace_id=${workspaceId}`);
            const optionArray = [{ id: null, label: 'Select Asana project' }];

            res.data.forEach((obj) => {
            optionArray.push({ id: obj.gid, label: obj.name });
            if (currentProjectId === obj.gid) {
                this.asana_form.asana_project_id = { id: obj.gid, label: obj.name };
            }
            });

            // Reactive set
            this.$set(this.asana_projects, workspaceId, optionArray);
        } finally {
            await this.$store.commit('set', ['showLoader', false]);
        }
    },

     async assignAsanaProject() {
        console.log(this.asana_form);

        const payload = {
            factory_id: this.asana_form.selected_factory_id,
            asana_workspace_id: this.asana_form.asana_workspace_id.id,
            asana_project_id: this.asana_form.asana_project_id.id
            }

            await this.$store.commit('set', ['showLoader', true]);
            await http.post(`/bind-asana-project-to-factory`, payload).then((res) => {
            this.$store.commit('set', ['showLoader', false]);

            const index = this.factories.findIndex(obj => obj.id === payload.factory_id);

            if (index !== -1) {
                this.$set(this.factories, index, {
                ...this.factories[index],
                asana_project_id: payload.asana_project_id,
                asana_workspace_id: payload.asana_workspace_id
                });
            }

            this.showToast("Project bound with factory successfully", "SUCCESS");
            this.$bvModal.hide("asanaProjectModal");
            });

        }
    }
}
</script>
<style lang="scss" scoped>
    $modal-bg : #F5F5F5;
    #factoryModal{
        background-color: rgba(0,0,0,0.2);
        .modal-header{
            border: none;
            padding-bottom: 0;
        }
        .modal-content{
            background-color: $modal-bg;
        }
        .text-primary{
            color: #009FE3 !important;
        }
    }
    .flag {
        display: inline-block;
        position:  relative;
        width: 16px;
        height: 11px;
        background: url('~@/assets/images/flags.png') no-repeat;
    }
    .wizard-header{
        display: none;
    }
    .modal-header{
        padding-bottom: 0;
        border: none;
    }
    .modal-dialog, .modal-body{
        margin: 0;
        padding: 0 !important;
    }
    .edit_factory{
        cursor: pointer;
    }
    .flag.flag-gu {
        background-position: -96px -55px;
    }
    .flag.flag-mn {
        background-position: -208px -88px;
    }
    .flag.flag-va {
        background-position: -48px -154px;
    }
    .flag.flag-tibet {
        background-position: -32px -143px;
    }
    .flag.flag-fo {
        background-position: -64px -44px;
    }
    .flag.flag-th {
        background-position: -16px -143px;
    }
    .flag.flag-tr {
        background-position: -144px -143px;
    }
    .flag.flag-tl {
        background-position: -80px -143px;
    }
    .flag.flag-kz {
        background-position: -144px -77px;
    }
    .flag.flag-zm {
        background-position: -16px -165px;
    }
    .flag.flag-uz {
        background-position: -32px -154px;
    }
    .flag.flag-dk {
        background-position: -64px -33px;
    }
    .flag.flag-scotland {
        background-position: -176px -121px;
    }
    .flag.flag-gi {
        background-position: -224px -44px;
    }
    .flag.flag-gy {
        background-position: -128px -55px;
    }
    .flag.flag-bj {
        background-position: -112px -11px;
    }
    .flag.flag-fr {
        background-position: -80px -44px;
    }
    .flag.flag-mo {
        background-position: -224px -88px;
    }
    .flag.flag-ir {
        background-position: -112px -66px;
    }
    .flag.flag-io {
        background-position: -80px -66px;
    }
    .flag.flag-tm {
        background-position: -96px -143px;
    }
    .flag.flag-ch {
        background-position: -96px -22px;
    }
    .flag.flag-mt {
        background-position: -32px -99px;
    }
    .flag.flag-nl {
        background-position: -240px -99px;
    }
    .flag.flag-gp {
        background-position: -16px -55px;
    }
    .flag.flag-im {
        background-position: -48px -66px;
    }
    .flag.flag-tv {
        background-position: -176px -143px;
    }
    .flag.flag-mu {
        background-position: -48px -99px;
    }
    .flag.flag-pe {
        background-position: -96px -110px;
    }
    .flag.flag-vi {
        background-position: -112px -154px;
    }
    .flag.flag-hn {
        background-position: -176px -55px;
    }
    .flag.flag-ss {
        background-position: -128px -132px;
    }
    .flag.flag-ae {
        background-position: -16px 0;
    }
    .flag.flag-td {
        background-position: -240px -132px;
    }
    .flag.flag-pw {
        background-position: 0 -121px;
    }
    .flag.flag-nu {
        background-position: -32px -110px;
    }
    .flag.flag-bt {
        background-position: -208px -11px;
    }
    .flag.flag-ms {
        background-position: -16px -99px;
    }
    .flag.flag-cv {
        background-position: -240px -22px;
    }
    .flag.flag-es {
        background-position: -224px -33px;
    }
    .flag.flag-mh {
        background-position: -144px -88px;
    }
    .flag.flag-la {
        background-position: -160px -77px;
    }
    .flag.flag-vn {
        background-position: -128px -154px;
    }
    .flag.flag-py {
        background-position: -16px -121px;
    }
    .flag.flag-br {
        background-position: -176px -11px;
    }
    .flag.flag-ye {
        background-position: -224px -154px;
    }
    .flag.flag-ie {
        background-position: 0 -66px;
    }
    .flag.flag-gh {
        background-position: -208px -44px;
    }
    .flag.flag-cg {
        background-position: -80px -22px;
    }
    .flag.flag-cu {
        background-position: -224px -22px;
    }
    .flag.flag-hu {
        background-position: -224px -55px;
    }
    .flag.flag-sg {
        background-position: -224px -121px;
    }
    .flag.flag-at {
        background-position: -176px 0;
    }
    .flag.flag-lk {
        background-position: -224px -77px;
    }
    .flag.flag-vu {
        background-position: -144px -154px;
    }
    .flag.flag-bo {
        background-position: -160px -11px;
    }
    .flag.flag-jo {
        background-position: -208px -66px;
    }
    .flag.flag-er {
        background-position: -208px -33px;
    }
    .flag.flag-za {
        background-position: -256px -154px;
    }
    .flag.flag-rs {
        background-position: -80px -121px;
    }
    .flag.flag-nr {
        background-position: -16px -110px;
    }
    .flag.flag-ls {
        background-position: -256px -77px;
    }
    .flag.flag-jm {
        background-position: -192px -66px;
    }
    .flag.flag-tz {
        background-position: -208px -143px;
    }
    .flag.flag-ki {
        background-position: -16px -77px;
    }
    .flag.flag-sj {
        background-position: 0 -132px;
    }
    .flag.flag-cz {
        background-position: -16px -33px;
    }
    .flag.flag-pg {
        background-position: -128px -110px;
    }
    .flag.flag-lv {
        background-position: -32px -88px;
    }
    .flag.flag-do {
        background-position: -96px -33px;
    }
    .flag.flag-lu {
        background-position: -16px -88px;
    }
    .flag.flag-no {
        background-position: -256px -99px;
    }
    .flag.flag-kw {
        background-position: -112px -77px;
    }
    .flag.flag-mx {
        background-position: -96px -99px;
    }
    .flag.flag-yt {
        background-position: -240px -154px;
    }
    .flag.flag-ly {
        background-position: -48px -88px;
    }
    .flag.flag-cy {
        background-position: 0 -33px;
    }
    .flag.flag-ph {
        background-position: -144px -110px;
    }
    .flag.flag-my {
        background-position: -112px -99px;
    }
    .flag.flag-sm {
        background-position: -48px -132px;
    }
    .flag.flag-et {
        background-position: -240px -33px;
    }
    .flag.flag-ru {
        background-position: -96px -121px;
    }
    .flag.flag-tj {
        background-position: -48px -143px;
    }
    .flag.flag-ai {
        background-position: -64px 0;
    }
    .flag.flag-pl {
        background-position: -176px -110px;
    }
    .flag.flag-kp {
        background-position: -64px -77px;
    }
    .flag.flag-uy {
        background-position: -16px -154px;
    }
    .flag.flag-gb {
        background-position: -112px -44px;
    }
    .flag.flag-gs {
        background-position: -64px -55px;
    }
    .flag.flag-kurdistan {
        background-position: -96px -77px;
    }
    .flag.flag-rw {
        background-position: -112px -121px;
    }
    .flag.flag-ec {
        background-position: -128px -33px;
    }
    .flag.flag-mm {
        background-position: -192px -88px;
    }
    .flag.flag-pa {
        background-position: -80px -110px;
    }
    .flag.flag-wales {
        background-position: -160px -154px;
    }
    .flag.flag-kg {
        background-position: -256px -66px;
    }
    .flag.flag-ve {
        background-position: -80px -154px;
    }
    .flag.flag-tk {
        background-position: -64px -143px;
    }
    .flag.flag-ca {
        background-position: -16px -22px;
    }
    .flag.flag-is {
        background-position: -128px -66px;
    }
    .flag.flag-ke {
        background-position: -240px -66px;
    }
    .flag.flag-ro {
        background-position: -64px -121px;
    }
    .flag.flag-gq {
        background-position: -32px -55px;
    }
    .flag.flag-pt {
        background-position: -256px -110px;
    }
    .flag.flag-tf {
        background-position: -256px -132px;
    }
    .flag.flag-ad {
        background-position: 0 0;
    }
    .flag.flag-sk {
        background-position: -16px -132px;
    }
    .flag.flag-pm {
        background-position: -192px -110px;
    }
    .flag.flag-om {
        background-position: -64px -110px;
    }
    .flag.flag-an {
        background-position: -112px 0;
    }
    .flag.flag-ws {
        background-position: -192px -154px;
    }
    .flag.flag-sh {
        background-position: -240px -121px;
    }
    .flag.flag-mp {
        background-position: -240px -88px;
    }
    .flag.flag-gt {
        background-position: -80px -55px;
    }
    .flag.flag-cf {
        background-position: -64px -22px;
    }
    .flag.flag-zanzibar {
        background-position: 0 -165px;
    }
    .flag.flag-mw {
        background-position: -80px -99px;
    }
    .flag.flag-catalonia {
        background-position: -32px -22px;
    }
    .flag.flag-ug {
        background-position: -240px -143px;
    }
    .flag.flag-je {
        background-position: -176px -66px;
    }
    .flag.flag-km {
        background-position: -32px -77px;
    }
    .flag.flag-in {
        background-position: -64px -66px;
    }
    .flag.flag-bf {
        background-position: -48px -11px;
    }
    .flag.flag-mc {
        background-position: -80px -88px;
    }
    .flag.flag-sy {
        background-position: -192px -132px;
    }
    .flag.flag-sn {
        background-position: -64px -132px;
    }
    .flag.flag-kr {
        background-position: -80px -77px;
    }
    .flag.flag-eu {
        background-position: -256px -33px;
    }
    .flag.flag-bn {
        background-position: -144px -11px;
    }
    .flag.flag-st {
        background-position: -144px -132px;
    }
    .flag.flag-england {
        background-position: -192px -33px;
    }
    .flag.flag-lc {
        background-position: -192px -77px;
    }
    .flag.flag-dm {
        background-position: -80px -33px;
    }
    .flag.flag-be {
        background-position: -32px -11px;
    }
    .flag.flag-ni {
        background-position: -224px -99px;
    }
    .flag.flag-ua {
        background-position: -224px -143px;
    }
    .flag.flag-mz {
        background-position: -128px -99px;
    }
    .flag.flag-pf {
        background-position: -112px -110px;
    }
    .flag.flag-tn {
        background-position: -112px -143px;
    }
    .flag.flag-ee {
        background-position: -144px -33px;
    }
    .flag.flag-xk {
        background-position: -208px -154px;
    }
    .flag.flag-sx {
        background-position: -176px -132px;
    }
    .flag.flag-sd {
        background-position: -192px -121px;
    }
    .flag.flag-gd {
        background-position: -128px -44px;
    }
    .flag.flag-ci {
        background-position: -112px -22px;
    }
    .flag.flag-sz {
        background-position: -208px -132px;
    }
    .flag.flag-cl {
        background-position: -144px -22px;
    }
    .flag.flag-fi {
        background-position: 0 -44px;
    }
    .flag.flag-ga {
        background-position: -96px -44px;
    }
    .flag.flag-jp {
        background-position: -224px -66px;
    }
    .flag.flag-de {
        background-position: -32px -33px;
    }
    .flag.flag-np {
        background-position: 0 -110px;
    }
    .flag.flag-re {
        background-position: -48px -121px;
    }
    .flag.flag-bg {
        background-position: -64px -11px;
    }
    .flag.flag-sc {
        background-position: -160px -121px;
    }
    .flag.flag-ng {
        background-position: -208px -99px;
    }
    .flag.flag-qa {
        background-position: -32px -121px;
    }
    .flag.flag-mk {
        background-position: -160px -88px;
    }
    .flag.flag-aw {
        background-position: -208px 0;
    }
    .flag.flag-kn {
        background-position: -48px -77px;
    }
    .flag.flag-al {
        background-position: -80px 0;
    }
    .flag.flag-bw {
        background-position: -240px -11px;
    }
    .flag.flag-um {
        background-position: -256px -143px;
    }
    .flag.flag-ky {
        background-position: -128px -77px;
    }
    .flag.flag-tt {
        background-position: -160px -143px;
    }
    .flag.flag-so {
        background-position: -80px -132px;
    }
    .flag.flag-lt {
        background-position: 0 -88px;
    }
    .flag.flag-by {
        background-position: -256px -11px;
    }
    .flag.flag-bb {
        background-position: 0 -11px;
    }
    .flag.flag-us {
        background-position: 0 -154px;
    }
    .flag.flag-md {
        background-position: -96px -88px;
    }
    .flag.flag-ag {
        background-position: -48px 0;
    }
    .flag.flag-hm {
        background-position: -160px -55px;
    }
    .flag.flag-as {
        background-position: -160px 0;
    }
    .flag.flag-eg {
        background-position: -160px -33px;
    }
    .flag.flag-sv {
        background-position: -160px -132px;
    }
    .flag.flag-sl {
        background-position: -32px -132px;
    }
    .flag.flag-fk {
        background-position: -32px -44px;
    }
    .flag.flag-am {
        background-position: -96px 0;
    }
    .flag.flag-ck {
        background-position: -128px -22px;
    }
    .flag.flag-tw {
        background-position: -192px -143px;
    }
    .flag.flag-kh {
        background-position: 0 -77px;
    }
    .flag.flag-to {
        background-position: -128px -143px;
    }
    .flag.flag-se {
        background-position: -208px -121px;
    }
    .flag.flag-cd {
        background-position: -48px -22px;
    }
    .flag.flag-pn {
        background-position: -208px -110px;
    }
    .flag.flag-gr {
        background-position: -48px -55px;
    }
    .flag.flag-id {
        background-position: -256px -55px;
    }
    .flag.flag-vc {
        background-position: -64px -154px;
    }
    .flag.flag-somaliland {
        background-position: -96px -132px;
    }
    .flag.flag-bi {
        background-position: -96px -11px;
    }
    .flag.flag-pk {
        background-position: -160px -110px;
    }
    .flag.flag-pr {
        background-position: -224px -110px;
    }
    .flag.flag-bd {
        background-position: -16px -11px;
    }
    .flag.flag-co {
        background-position: -192px -22px;
    }
    .flag.flag-fm {
        background-position: -48px -44px;
    }
    .flag.flag-bm {
        background-position: -128px -11px;
    }
    .flag.flag-ar {
        background-position: -144px 0;
    }
    .flag.flag-bv {
        background-position: -224px -11px;
    }
    .flag.flag-sb {
        background-position: -144px -121px;
    }
    .flag.flag-mq {
        background-position: -256px -88px;
    }
    .flag.flag-eh {
        background-position: -176px -33px;
    }
    .flag.flag-bh {
        background-position: -80px -11px;
    }
    .flag.flag-it {
        background-position: -144px -66px;
    }
    .flag.flag-hr {
        background-position: -192px -55px;
    }
    .flag.flag-sa {
        background-position: -128px -121px;
    }
    .flag.flag-mv {
        background-position: -64px -99px;
    }
    .flag.flag-mg {
        background-position: -128px -88px;
    }
    .flag.flag-dz {
        background-position: -112px -33px;
    }
    .flag.flag-gg {
        background-position: -192px -44px;
    }
    .flag.flag-gm {
        background-position: -256px -44px;
    }
    .flag.flag-af {
        background-position: -32px 0;
    }
    .flag.flag-li {
        background-position: -208px -77px;
    }
    .flag.flag-sr {
        background-position: -112px -132px;
    }
    .flag.flag-vg {
        background-position: -96px -154px;
    }
    .flag.flag-cr {
        background-position: -208px -22px;
    }
    .flag.flag-tc {
        background-position: -224px -132px;
    }
    .flag.flag-ao {
        background-position: -128px 0;
    }
    .flag.flag-ma {
        background-position: -64px -88px;
    }
    .flag.flag-mr {
        background-position: 0 -99px;
    }
    .flag.flag-gn {
        background-position: 0 -55px;
    }
    .flag.flag-ne {
        background-position: -176px -99px;
    }
    .flag.flag-nf {
        background-position: -192px -99px;
    }
    .flag.flag-wf {
        background-position: -176px -154px;
    }
    .flag.flag-hk {
        background-position: -144px -55px;
    }
    .flag.flag-gf {
        background-position: -160px -44px;
    }
    .flag.flag-ps {
        background-position: -240px -110px;
    }
    .flag.flag-ic {
        background-position: -240px -55px;
    }
    .flag.flag-cw {
        background-position: -256px -22px;
    }
    .flag.flag-ml {
        background-position: -176px -88px;
    }
    .flag.flag-ax {
        background-position: -224px 0;
    }
    .flag.flag-gl {
        background-position: -240px -44px;
    }
    .flag.flag-dj {
        background-position: -48px -33px;
    }
    .flag.flag-cn {
        background-position: -176px -22px;
    }
    .flag.flag-ht {
        background-position: -208px -55px;
    }
    .flag.flag-lr {
        background-position: -240px -77px;
    }
    .flag.flag-tg {
        background-position: 0 -143px;
    }
    .flag.flag-ba {
        background-position: -256px 0;
    }
    .flag.flag-ge {
        background-position: -144px -44px;
    }
    .flag.flag-bz {
        background-position: 0 -22px;
    }
    .flag.flag-au {
        background-position: -192px 0;
    }
    .flag.flag-iq {
        background-position: -96px -66px;
    }
    .flag.flag-cm {
        background-position: -160px -22px;
    }
    .flag.flag-gw {
        background-position: -112px -55px;
    }
    .flag.flag-az {
        background-position: -240px 0;
    }
    .flag.flag-na {
        background-position: -144px -99px;
    }
    .flag.flag-fj {
        background-position: -16px -44px;
    }
    .flag.flag-zw {
        background-position: -32px -165px;
    }
    .flag.flag-bs {
        background-position: -192px -11px;
    }
    .flag.flag-il {
        background-position: -16px -66px;
    }
    .flag.flag-nz {
        background-position: -48px -110px;
    }
    .flag.flag-me {
        background-position: -112px -88px;
    }
    .flag.flag-si {
        background-position: -256px -121px;
    }
    .flag.flag-nc {
        background-position: -160px -99px;
    }
    .flag.flag-lb {
        background-position: -176px -77px;
    }
</style>